import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from './context/theme';
import { ToastProvider } from './context/toast';
import { AuthProvider } from './context/auth';
import { ConfirmProvider } from './context/confirm';
import App from './App';
import './styles/global.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThemeProvider>
      <ToastProvider>
        <AuthProvider>
          <ConfirmProvider>
            <App />
          </ConfirmProvider>
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  </React.StrictMode>
);
